import React, { useRef, useCallback } from 'react'
import { LANGUAGES } from '../common'
import Language from './Language'
import { useScrollAnimation } from '../hooks/useScrollAnimation'
import { useTextScramble } from '../hooks/useTextScramble'

const ToolkitSection = () => {
	const [ref, isVisible] = useScrollAnimation(0.05)
	const scrambled = useTextScramble('TOOLKIT', isVisible, 1000)
	const cardRefs = useRef([])

	const handleMouseMove = useCallback((e) => {
		cardRefs.current.forEach((card) => {
			if (!card) return
			const rect = card.getBoundingClientRect()
			const cx = rect.left + rect.width / 2
			const cy = rect.top + rect.height / 2
			const dist = Math.sqrt((e.clientX - cx) ** 2 + (e.clientY - cy) ** 2)
			const maxDist = 140
			const intensity = Math.max(0, 1 - dist / maxDist)

			if (intensity > 0.01) {
				card.style.boxShadow = `0 0 ${intensity * 22}px ${intensity * 5}px rgba(59,130,246,${intensity * 0.4}), inset 0 0 ${intensity * 8}px rgba(59,130,246,${intensity * 0.08})`
				card.style.borderColor = `rgba(59,130,246,${0.08 + intensity * 0.55})`
				card.style.transform = `scale(${1 + intensity * 0.07}) translateY(${-intensity * 4}px)`
				card.style.transition = 'box-shadow 0.05s, border-color 0.05s, transform 0.05s'
			} else {
				card.style.boxShadow = ''
				card.style.borderColor = ''
				card.style.transform = ''
				card.style.transition = 'box-shadow 0.3s, border-color 0.3s, transform 0.3s'
			}
		})
	}, [])

	const handleMouseLeave = useCallback(() => {
		cardRefs.current.forEach((card) => {
			if (!card) return
			card.style.boxShadow = ''
			card.style.borderColor = ''
			card.style.transform = ''
			card.style.transition = 'box-shadow 0.4s ease, border-color 0.4s ease, transform 0.4s ease'
		})
	}, [])

	return (
		<section
			id='toolkit'
			className='py-24 px-6 lg:px-12'
			ref={ref}
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}>
			<div className='max-w-6xl mx-auto'>
				{/* Section header */}
				<div
					className='mb-16 transition-all duration-700'
					style={{
						opacity: isVisible ? 1 : 0,
						transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
					}}>
					<p className='text-blue-400 font-mono text-xs tracking-[0.25em] uppercase mb-3'>
						Technologies
					</p>
					<h2 className='text-4xl lg:text-6xl font-bold text-white'>
						My{' '}
						<span className='bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent font-mono'>
							{scrambled}
						</span>
					</h2>
					<div className='mt-4 w-16 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full' />
				</div>

				{/* Skills grid */}
				<div className='grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-3'>
					{LANGUAGES.map((language, i) => (
						<div
							key={language.name}
							ref={(el) => (cardRefs.current[i] = el)}
							className='transition-all duration-500'
							style={{
								opacity: isVisible ? 1 : 0,
								transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
								transitionDelay: `${i * 50}ms`,
							}}>
							<Language name={language.name} icon={language.icon} svg={language.svg} />
						</div>
					))}
				</div>
			</div>
		</section>
	)
}

export default ToolkitSection
